'use client';

import { Trans, t } from '@lingui/macro';
import { Box, Container, Stack, Typography } from '@mui/material';
import { AppPalettes, PageHeader } from '@prismo-io/design-system';
import Image from 'next/image';
import type { FC } from 'react';

import auraImg from '@/assets/aura/app/no-result.svg';
import DefaultAuraLogo from '@/assets/aura/app/primary/common/icone-aura.svg';
import backgroundImg from '@/assets/aura/backgrounds/no-result.png';
import { ThemeProvider } from '@prismo-io/design-system/theme-provider';
import type { ResponseValueSchemaT } from '../../utils/fetch-user-result-locked';
import { Countdown } from '../count-down';

type Props = {
  result: NonNullable<ResponseValueSchemaT>;
};

export const AuraBlockedResult: FC<Props> = (props) => {
  const { result } = props;

  const auraTitle = (
    <>
      <Typography
        color="white"
        fontSize={{ none: '1.10rem', sm: '1.25rem', md: '1.75rem' }}
        fontWeight="bolder"
      >
        Aura
      </Typography>
      <Typography
        color="white"
        fontSize={{ none: '1.10rem', sm: '1.25rem', md: '1.75rem' }}
      >
        |
      </Typography>
      <Typography
        color="white"
        fontSize={{ none: '1.10rem', sm: '1.25rem', md: '1.75rem' }}
      >
        {t`Comportement`}
      </Typography>
    </>
  );

  return (
    <ThemeProvider
      theme={AppPalettes.light}
      options={{ key: 'aura-blocked-result' }}
    >
      <Box
        position="relative"
        width="100%"
        height="100vh"
        component="section"
        overflow="hidden"
      >
        <Box
          component="div"
          position="absolute"
          top="0"
          bottom="0"
          right="0"
          left="0"
        >
          <Image
            src={backgroundImg}
            alt=""
            style={{ objectFit: 'cover', objectPosition: 'center' }}
            fill
          />
        </Box>
        <PageHeader pageImg={DefaultAuraLogo} pageTitleRender={auraTitle} />
        <Box
          component="div"
          height="100%"
          py={{ none: '1.5rem', sm: '2rem', lg: '4rem', xl: '6rem' }}
          overflow="auto"
        >
          <Container maxWidth="md">
            <Stack
              position="relative"
              direction="column"
              alignItems="center"
              spacing={4}
            >
              <Box
                component="div"
                position="relative"
                width="100%"
                height={{ none: '10rem', sm: '15rem' }}
              >
                <Image
                  src={auraImg}
                  alt=""
                  style={{ objectFit: 'contain', objectPosition: 'center' }}
                  fill
                />
              </Box>
              <Typography
                variant="h2"
                fontSize="1.5rem"
                lineHeight="2rem"
                textAlign="center"
                color="primary.main"
              >
                <Trans>Vous avez déjà passé Aura</Trans>
              </Typography>
              <Typography
                fontSize="1.5rem"
                color="white"
                textAlign="center"
                lineHeight="2rem"
              >
                {result.unlocked_at instanceof Date ? (
                  <Countdown endDate={result.unlocked_at} />
                ) : (
                  <Trans>
                    Résultats en attente de déblocage par votre administrateur.
                    Ce dernier bénéficie d'un accès direct à vos résultats et
                    peut choisir quand les débloquer, afin de vous assurer une
                    restitution optimale.
                  </Trans>
                )}
              </Typography>
            </Stack>
          </Container>
        </Box>
      </Box>
    </ThemeProvider>
  );
};
